




















































import Vue from 'vue';
import Tooltip from '@/components/tooltip/Tooltip.vue';
import { Delivery, ProductPriceStock, WarehouseStock } from '@/model/product-price-stock';
import { Config } from '@/model/config';
import { Util } from '@/util/util';
import { translate } from '@/filters';
import WarehouseStockBackorder from '@/components/v2/pps-actions-module/WarehouseStockBackorder.vue';
import WarehouseStockAvailable from '@/components/v2/pps-actions-module/WarehouseStockAvailable.vue';
import { ppsMixin } from "@/components/v2/pps-actions-module/ppsMixin";

interface WarehouseStocksMixin {
  warehouseStocks: WarehouseStock[];
}

export default Vue.extend({
  name: 'WarehouseStock',
  mixins: [ppsMixin],
  components: {
    WarehouseStockAvailable,
    WarehouseStockBackorder,
    Tooltip
  },
  props: {
    pps: {
      type: Object as () => ProductPriceStock,
      required: true
    },
    productBrand: {
      type: String,
      required: true,
      default: ''
    },
    productBusinessUnit: {
      type: String,
      required: true,
      default: ''
    },
    config: {
      type: Object as () => Config,
      default: Util.getConfig
    },
    displayDeliveryEstimate: {
      type: Boolean,
      default: false
    },
    colorizeNumber: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    stock(): number {
      if (this.pps) {
        return this.pps.totalStock;
      }
      return 0;
    },
    selectedWarehouseStock(): WarehouseStock | undefined {
      const availableStocks: WarehouseStock[] = ((this as unknown) as WarehouseStocksMixin).warehouseStocks;

      // First try to find a stock that is both in stock and preferred.
      let selected: WarehouseStock | undefined = availableStocks.find(s => s.stock > 0 && true === s.preferred);

      // If noo preferred stock is available, find any stock that is in the stock
      // or has pending deliveries
      if (selected === undefined) {
        selected = availableStocks.find(s => s.stock > 0 || (s.deliveries !== undefined && s.deliveries.length > 0));
      }

      return selected;
    },
  },
});
